import _ from "lodash";
import React, { useState } from "react";
import withLoader from "UIComponents/GqlWithLoader";
import { graphql, compose } from "lib/apolloClient";
import classes from "./StandardListWithSearch.scss";

import { EmptyState, SearchInput } from "@toddle-edu/ds-web";
import {
  NoSearchInFilterIllustration,
  EvidenceIllustration,
} from "@toddle-edu/ds-theme";
import { getSnpSetDetailsQuery } from "SnP/modules/SnPQueries";
import { getSnpSetDetailsFromCache } from "SnP/modules/SnPGraphqlHelpers";
import StandardList from "./StandardList";
import { getStandardsMemoized, getFilteredStandardsMemoized } from "./utils";

const StandardListWithSearch = props => {
  const [searchText, setSearchText] = useState("");
  const {
    updateSelectedPractices,
    t,
    standards,
    practiceListsCollection,
    itemDetails,
    cycleDetails,
    testId,
  } = props;

  const matchingStandards = getFilteredStandardsMemoized({
    standards,
    searchText,
  });

  return (
    <div className={classes.container}>
      <div className={classes.searchContainer}>
        <SearchInput
          placeholder={t("common:search_for_with_label", {
            label: t("snp:practices_or_requirements"),
          })}
          onChange={setSearchText}
          size="medium"
          dsVersion={"2.0"}
          focusSearchBySlash={true}
          testId={`${testId}-snp`}
        />
      </div>
      {_.size(matchingStandards) ? (
        <div className={classes.standardsContainer}>
          <div className={classes.standardsScrollContainer}>
            <StandardList
              practiceListsCollection={practiceListsCollection}
              updateSelectedPractices={updateSelectedPractices}
              areAllStandardsOpen={!!_.size(searchText)}
              standards={matchingStandards}
              itemDetails={itemDetails}
              cycleDetails={cycleDetails}
              testId={testId}
            />
          </div>
        </div>
      ) : _.size(searchText) ? (
        <div className={classes.noDataContainer}>
          <EmptyState
            dsVersion="2.0"
            illustration={NoSearchInFilterIllustration}
            title={t("common:noResultHeading")}
            subtitle={t("common:no_items_matching_your_search")}
            size="small"
          />
        </div>
      ) : (
        <div className={classes.noDataContainer}>
          <EmptyState
            dsVersion="2.0"
            illustration={EvidenceIllustration}
            title={t("common:no_with_label", {
              label: t("common:practice_plural"),
            })}
            size="small"
          />
        </div>
      )}
    </div>
  );
};

export default compose(
  graphql(getSnpSetDetailsQuery, {
    name: "getSnpSetDetails",
    alias: "getSnpSetDetails",
    options: ({ setId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        setId,
      },
    }),
    props({ getSnpSetDetails: { networkStatus }, ownProps: { setId, t } }) {
      const queryData = getSnpSetDetailsFromCache({ setId });

      const standards = getStandardsMemoized({ frameworks: queryData, t });

      return {
        isData: !_.isEmpty(queryData),
        standards,
        isLoading: _.includes([1, 2], networkStatus),
      };
    },
  }),
  withLoader
)(StandardListWithSearch);
